import { useRef } from "react";

// Vertical SUDS thermometer: drag, click or use arrow keys (0 = calm, 10 = crisis).
export function Thermometer({ value, onChange, height = 340 }) {
  const ref = useRef(null);
  const setFromY = (clientY) => {
    const r = ref.current.getBoundingClientRect();
    const pct = 1 - Math.min(1, Math.max(0, (clientY - r.top) / r.height));
    onChange(Math.round(pct * 10));
  };
  const onDown = (e) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    setFromY(e.clientY);
  };
  const onMove = (e) => e.buttons && setFromY(e.clientY);
  const onKey = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowRight") onChange(Math.min(10, value + 1));
    if (e.key === "ArrowDown" || e.key === "ArrowLeft") onChange(Math.max(0, value - 1));
  };
  const pct = value / 10;
  return (
    <div className="flex flex-col items-center select-none">
      <div
        ref={ref}
        role="slider" aria-valuemin={0} aria-valuemax={10} aria-valuenow={value} tabIndex={0}
        data-testid="suds-thermometer"
        onPointerDown={onDown} onPointerMove={onMove} onKeyDown={onKey}
        className="relative w-[64px] rounded-full bg-t-surface3 border border-t-border cursor-grab active:cursor-grabbing outline-none focus-visible:ring-4 focus-visible:ring-[var(--brand3)] touch-none"
        style={{ height }}
      >
        <div className="absolute inset-x-[7px] bottom-[7px] rounded-full overflow-hidden" style={{ top: 7 }}>
          <div
            className="absolute inset-x-0 bottom-0 rounded-full transition-[height] duration-300 ease-out"
            style={{ height: `${Math.max(14, pct * 100)}%`, background: "linear-gradient(to top, var(--cold), var(--mid) 55%, var(--hot))", backgroundSize: `100% ${height}px`, backgroundPosition: "bottom" }}
          />
        </div>
        {Array.from({ length: 11 }).map((_, i) => (
          <span key={i} className="absolute -right-3 w-2 h-[2px] rounded bg-t-border2" style={{ bottom: `${7 + (i / 10) * (height - 14)}px` }} />
        ))}
        <div
          className="absolute left-1/2 -translate-x-1/2 w-[78px] h-[78px] -mb-[39px] rounded-full bg-t-surface border-4 grid place-items-center shadow-lg transition-[bottom] duration-300 ease-out"
          style={{ bottom: `${7 + pct * (height - 14)}px`, borderColor: value >= 7 ? "var(--hot)" : value >= 4 ? "var(--mid)" : "var(--cold)" }}
        >
          <span className="text-[26px] font-bold text-t-on" data-testid="suds-value">{value}</span>
        </div>
      </div>
    </div>
  );
}
